// components/FilterModal.jsx
import React from 'react';
import { CloseIcon } from '../../public/icons';

const FilterModal = ({ 
  isOpen, 
  onClose, 
  filters, 
  onFilterChange, 
  onClearFilters, 
  hasActiveFilters 
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-[100]"
        onClick={onClose}
      />
      
      {/* Filter Panel */}
      <div className="fixed right-0 top-0 h-full w-full md:w-[40%] bg-[#F9F6F2] z-[999] overflow-y-auto">
        <div className="p-6 h-full flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-medium text-[#1C2A46]">Filter Collections</h3>
            <button 
              onClick={onClose}
              className="p-1 hover:bg-[#F8F8F8] border border-[#DBDBDB]"
            >
              <CloseIcon />
            </button>
          </div>
          
          <p className="text-[#6B635D] text-sm mb-8 text-left">
            Narrow your search to find the memories that matter to you.
          </p>

          {/* Availability Filter */}
          <div className="mb-8">
            <h4 className="text-lg font-medium text-[#1C2A46] mb-4 text-left">Availability</h4>
            <div className="space-y-3">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={filters.availability.inStock}
                  onChange={() => onFilterChange('availability', 'inStock')}
                  className="w-4 h-4 text-[#D4A574] border-[#DBDBDB] rounded focus:ring-[#D4A574]"
                />
                <span className="text-[#1C2A46]">In Stock</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={filters.availability.outOfStock}
                  onChange={() => onFilterChange('availability', 'outOfStock')}
                  className="w-4 h-4 text-[#D4A574] border-[#DBDBDB] rounded focus:ring-[#D4A574]"
                />
                <span className="text-[#1C2A46]">Out of Stock</span>
              </label>
            </div>
          </div>

          {/* Category Filter */}
          <div className="mb-8">
            <h4 className="text-lg font-medium text-[#1C2A46] mb-4 text-left">Search by Category</h4>
            <div className="space-y-3">
              {[
                { key: 'travelPlaces', label: 'Travel & Places' },
                { key: 'namesAndMeaning', label: 'Names & Their Meaning' },
                { key: 'loveRelationships', label: 'Love & Relationships' },
                { key: 'familyHome', label: 'Family & Home' },
                { key: 'cultureHeritage', label: 'Culture & Heritage' },
                { key: 'faithSpiritual', label: 'Faith & Spiritual' },
                { key: 'legacyReflection', label: 'Legacy & Reflection' },
                { key: 'celebrationsMilestones', label: 'Celebrations & Milestones' },
                { key: 'inspirationalQuotes', label: 'Inspirational Quotes' }
              ].map(({ key, label }) => (
                <label key={key} className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={filters.categories[key]}
                    onChange={() => onFilterChange('categories', key)}
                    className="w-4 h-4 text-[#D4A574] border-[#DBDBDB] rounded focus:ring-[#D4A574]"
                  />
                  <span className="text-[#1C2A46]">{label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Apply Filter Button - Now at bottom with padding */}
          <div className="mt-auto pt-6 pb-6 border-t border-[#DBDBDB]">
            <div className="flex gap-3">
              {hasActiveFilters() ? (
                <>
                  <button 
                    onClick={onClearFilters}
                    className="flex-1 py-3 px-4 border border-[#DBDBDB] text-[#1C2A46] hover:bg-[#F8F8F8] transition-colors"
                  >
                    Clear All
                  </button>
                  <button 
                    onClick={onClose}
                    className="flex-1 py-3 px-4 bg-[#D2A146] text-white hover:bg-[#C49660] transition-colors"
                  >
                    Apply Filter
                  </button>
                </>
              ) : (
                <button 
                  onClick={onClose}
                  className="w-full py-3 px-4 bg-[#D2A146] text-white hover:bg-[#C49660] transition-colors"
                >
                  Apply Filter
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterModal;
